// extracted by mini-css-extract-plugin
export default {"BaseHeader":"BaseHeader_BaseHeader__Q+wt3"};